module.exports = __webpack_public_path__ + "img/se.himalaya.544e3eaa.webp";